export default __webpack_public_path__ + "static/media/Startup_SVG.23a9d437.svg";